import { useLayoutEffect, useState } from 'react';

import { ImageRequireSource } from 'react-native';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys.ts';

import { getSettledResponseData } from 'utils/axios/nagra/utils.ts';

const {
    ACCESSIBILITY: {
        SETTINGS: {
            MY_STREAMIN_SUBSCRIPTIONS: {
                ACCESSIBILITY_NETFLIX_LOGO,
                ACCESSIBILITY_DA_VINCI_LOGO,
                ACCESSIBILITY_FOUR_NET_LOGO,
                ACCESSIBILITY_PRIME_VIDEO_LOGO,
                ACCESSIBILITY_HBO_MAX_LOGO,
                ACCESSIBILITY_RTL_PLUS_LOGO,
                ACCESSIBILITY_TV_TWO_LOGO,
                ACCESSIBILITY_FILM_BOX_PLUS_LOGO,
            },
        },
    },
} = LANGUAGE_KEYS;

function useLogos() {
    const { t } = useTranslation();

    const [logos, setLogos] = useState<
        { logo: ImageRequireSource; label: string }[]
    >([]);

    useLayoutEffect(() => {
        (async () => {
            try {
                const accessibilityLabels = [
                    t(ACCESSIBILITY_NETFLIX_LOGO),
                    t(ACCESSIBILITY_DA_VINCI_LOGO),
                    t(ACCESSIBILITY_FOUR_NET_LOGO),
                    t(ACCESSIBILITY_PRIME_VIDEO_LOGO),
                    t(ACCESSIBILITY_HBO_MAX_LOGO),
                    t(ACCESSIBILITY_RTL_PLUS_LOGO),
                    t(ACCESSIBILITY_TV_TWO_LOGO),
                    t(ACCESSIBILITY_FILM_BOX_PLUS_LOGO),
                ];
                const imagesSettledResponse = await Promise.allSettled([
                    import('../images/netflix.png'),
                    import('../images/davinci.png'),
                    import('../images/4net.png'),
                    import('../images/primevideo.png'),
                    import('../images/max.png'),
                    import('../images/rtl.png'),
                    import('../images/tv2.png'),
                    import('../images/filmbox.png'),
                ]);

                setLogos(
                    imagesSettledResponse.map((response, index) => ({
                        logo: getSettledResponseData(response)?.default,
                        label: accessibilityLabels[index] || '',
                    })),
                );
            } catch (error) {
                if (__DEV__) {
                    console.error(error);
                }
            }
        })();
    }, []);

    return logos;
}

export default useLogos;
